module.exports = __webpack_public_path__ + "static/media/Score-High.7a7ea270.svg";